import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { ForkalkylsmallarComponent } from "../forkalkylsmallar.component";

@Injectable({
    providedIn: "root"
})
export class ForkalkylsmallarDialogService {
    private readonly ngbModalService = inject(NgbModal);

    openForkalkylModal(): Observable<any> {
        const modalRef = this.ngbModalService.open(ForkalkylsmallarComponent, {
            keyboard: false,
            backdrop: "static",
            size: "xl"
        });
        modalRef.componentInstance.isModalActive = true;
        return from(modalRef.result);
    }

}
